module.exports = __webpack_public_path__ + "static/img/top2.3fc0b225.png";